import React from 'react';
import { useNavigate } from 'react-router-dom';
import BottomTabNavigation from '../../components/openplay/BottomTabNavigation';
import Icon from '../../components/openplay/OpenPlayIcon';
import { supabase } from '../../lib/supabaseClient';
import LoginRequiredModal from '../../components/ui/LoginRequiredModal';

const OpenPlayToolsPage = () => {
  const navigate = useNavigate();
  const [loginRequiredOpen, setLoginRequiredOpen] = React.useState(false);

  const navigateWithAuth = async (path) => {
    const { data } = await supabase.auth.getSession();
    const authed = Boolean(data?.session?.user);
    if (!authed) {
      setLoginRequiredOpen(true);
      return;
    }
    navigate(path);
  };

  const tools = [
    {
      id: 'event',
      title: '이벤트 관리',
      description: '다양한 매치를 자유롭게 만들어서 카카오톡 및 각종 게시판과 URL로 공유해보세요',
      icon: 'PaperAirplaneIcon',
      onClick: () => navigateWithAuth('/session-list-dashboard/invite'),
    },
    {
      id: 'participated',
      title: '참여 중 이벤트',
      description: '내가 참여했거나 참여 중인 이벤트 기록을 확인해보세요',
      icon: 'ClipboardDocumentListIcon',
      onClick: () => navigateWithAuth('/openplay/participated-events'),
    },
    {
      id: 'bracket',
      title: '대진표 작성',
      description: '다양한 룰 형식에 맞게 대진표를 작성하고 URL로 공유하세요',
      icon: 'TrophyIcon',
      onClick: () => navigateWithAuth('/session-list-dashboard/bracket'),
    },
    {
      id: 'member',
      title: '맴버',
      description: '당신만의 회원을 등록해 데이터베이스를 구축하세요',
      icon: 'UsersIcon',
      onClick: () => navigateWithAuth('/member-management'),
    },
    {
      id: 'notify',
      title: '알림',
      description: '카카오톡 연동 및 다양한 이벤트 시 알림을 설정해보세요',
      icon: 'BellIcon',
      onClick: () => navigateWithAuth('/openplay/notifications'),
    },
  ];

  const visibleTools = tools.filter((tool) => !['bracket', 'member', 'notify'].includes(tool.id));

  return (
    <div className="min-h-screen bg-background">
      <div className="md:pl-[240px]">
        <main className="pt-6 md:pt-10 pb-[calc(84px+env(safe-area-inset-bottom,16px))] md:pb-0">
          <div className="max-w-5xl mx-auto px-4 md:px-6 lg:px-8">
            <div className="mb-6 md:mb-8">
              <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground mb-2">도구</h1>
              <p className="text-base md:text-lg caption text-muted-foreground">기능을 사용하려면 로그인이 필요합니다</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
              {visibleTools.map((tool) => (
                <button
                  key={tool.id}
                  className="bg-card border border-border rounded-xl hover-lift transition-athletic p-5 md:p-6 flex flex-col items-start text-left"
                  onClick={tool.onClick}
                  type="button"
                >
                  <div className="w-14 h-14 bg-primary/10 rounded-xl flex items-center justify-center flex-shrink-0">
                    <Icon name={tool.icon} size={30} className="text-primary" />
                  </div>
                  <div className="mt-4">
                    <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground">{tool.title}</h2>
                    <p className="text-sm caption text-muted-foreground mt-2 leading-relaxed">{tool.description}</p>
                  </div>
                </button>
              ))}
            </div>
          </div>
        </main>
      </div>

      <BottomTabNavigation userRole="player" />

      <LoginRequiredModal
        isOpen={loginRequiredOpen}
        onClose={() => setLoginRequiredOpen(false)}
      />
    </div>
  );
};

export default OpenPlayToolsPage;
